import "./ExpenseFilter.css";

function ExpenseFilter(props){

    const yearHandler=(event)=>{
        props.expensef(event.target.value);
    }

    // select default value as the props expense current year, and then passing onChange
    // referencing yearHandler to change the year to selected year.
    return (
        <div className="expensefilter">
            <label>Filter by year-</label>
            <select value={props.expenseyear} onChange={yearHandler}>
                <option value="select">select</option>
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
            </select>
        </div>
    );
}

export default ExpenseFilter;